import { Element } from "./Element.mjs";
import { isArrayOf } from "./validation/index.mjs";
export var ComposedElement;

(function (ComposedElement) {
  function isComposedElement(value, type) {
    if (type === undefined ? Element.isElement(value) : Element.isElement(value, type)) {
      return 'children' in value && Array.isArray(value.children);
    }

    return false;
  }

  ComposedElement.isComposedElement = isComposedElement;

  function validateComposedElement(value, type, validateChild) {
    var isValid = isComposedElement(value, type) && value.type === type && isArrayOf(value.children, child => Boolean(validateChild(child)));
    return isValid ? value : null;
  }

  ComposedElement.validateComposedElement = validateComposedElement;
})(ComposedElement || (ComposedElement = {}));